'use strict';
(function($) {
	$.widget('Vetology.LogServerList',{
		"options": {
			table: null,
			dlg: null
		},

		_init: function() {
			let o = this;
			this.options.table = $("#log-server-table").DataTable({
				'ajax': {
					url: "/admin/log-viewer/data",
					type: "get",
					timeout: 10000,
					dataSrc: function(json) {
						return json.data;
					},
					reload: function(data) {
						return data;
					}
				},
				columns: [
					{
						data: function(opts) {
							return "<span class='vetology-icon vetology-menu2  action-btn'></span>";
						},
						orderable: false,
						className: 'action-col'
					},
					{
						data: 'name',
						className: 'nameCol',
						orderable: false
					},
					{
						data: 'ipAddress',
						className: 'ipAddressCol'
					},
					{
						data: {
						_: 'lastLogTime.display',
						sort: 'lastLogTime.timestamp'
						},
						className: 'lastLogTimeCol'
					},
					{
						data: 'lastLogLine',
						className: 'lastLogLineCol',
						orderable: false,
						searchable: true
					},
					{
						data: function(opts) {
							return "<button class='btn btn-sm btn-primary remove-server-btn'>Remove</button>";
						},
						className: 'actionsCol'
					}
				],
				'autowidth': true,
				'scrollx': true,
				'info': false,
				'paging': false,
//					'searching': false,
				'responsive': true,
				'order': [[2, 'asc']],
				'dom': 'ltr'

			});

			o._createColumnFilters();

			setInterval(function() {
				if (!o._checkForChildRows()) {
					o.options.table.ajax.reload(function(json) {
						// just update the data in log time and last log
						$.each(json.data, function(idx, rowData) {
							const $tr = $("#row_" + rowData.id);
							const row = o.options.table.row($tr);
							const $logTimeCell = $(".lastLogTimeCol", $tr);
							const logTimeCell = o.options.table.cell($logTimeCell);
							logTimeCell.data(rowData.lastLogTime.display);
							const $logMsgCell = $(".lastLogLineCol", $tr);
							const logMsgCell = o.options.table.cell($logMsgCell);
							logMsgCell.data(rowData.lastLogLine);
						});
					}, true);
				}
			}, 15000);

			o._addEventListeners();

			// init data in table
			o.options.table.ajax.reload(null, false);
		},

		_addEventListeners: function() {
			let o = this;

			this._on(this.element, {
				'click #add-log-server-btn': this._addLogServer,
				'click .action-btn': this._performRowAction
			});

			$("#log-server-table thead th input").each(function(i, el) {
				$(el).on('keyup change', function(e) {
					let colNum = $(e.currentTarget).parent().index();
					if (o.options.table.column(colNum).search() !== e.currentTarget.value) {
						o.options.table.column(colNum).search(e.currentTarget.value).draw();
					}
				});
			});
		},

		_checkForChildRows: function() {
			const o = this;
			let hasChild = false;
			o.options.table.rows().every(function(rowIdx, tableLoop, rowLoop) {
				if (this.child.isShown()) {
					hasChild = true;
				}
			});
			return hasChild;
		},

		_createColumnFilters: function() {
			var o = this;

			o._createColumnInputFilter('thead .last-log-line-col', 'Enter search phrase');

		},

		_createColumnInputFilter: function(cls, placeholder) {
			let $th = $(cls);
			let $input = $("<input type='text' placeholder='" + placeholder + "'/>");
			$th.append($input);
		},



		_addLogServer: function() {
			const o = this;
			this.options.dlg = $("#add-server-dlg").dialog({
				autoOpen: true,
				height: 300,
				width: 450,
				modal: true,
				buttons: {
					"Add": o._submitLogServer,
					Cancel: function() {
						o.options.dlg.dialog("close");
					}
				},
				close: function() {
					o.options.dlg.dialog('destroy');
				}
			});
		},

		_performRowAction: function(event) {
			const o = this;
			const $tr = $(event.currentTarget).closest('tr');
			const row = o.options.table.row($tr);

			if (row.child.isShown()) {
				row.child.hide();
				$tr.removeClass('shown');
			} else {
                const rowData = row.data();
                if (!(typeof rowData !== "undefined" && typeof rowData.lastLogLine != "undefined" && rowData.lastLogLine == "No logs available on this server")) {
                    row.child(o._formatChildRow(row.data())).show();
                    $tr.addClass('shown');
                }
			}
		},

		_formatChildRow: function(data) {
			const $table = $("<table cellpadding='5' cellspacing='0' border='0' style='padding-left:50px'></table>");
			$table.append("<thead><tr class='success'><th class='text-center'>View Logs</th></tr></thead>");
			const $row = $("<tr/>");
			const $cell = $("<td/>");
			const $button = $("<a href='/admin/log-viewer/view-logs?id=" +  data.id + "' data-content='<b>" + data.id + "' class='button-simple' data-toggle='popinfo' title='View Logs'/>");
			const $tbody = $("<tbody/>");
			$button.append($("<span class='vetology-icon vetology-edit'/>"));
			$cell.append($button);
			$row.append($cell);
			$tbody.append($row);
			$table.append($tbody);
			return $table.get();
		},

		_submitLogServer: function(event) {
			const o = this;
			const id = $("option:selected", "#log-server-selector").val();
			let data = {
				_token: $("#log-server-selector").data('token'),
				'id': id
			};
			$.post("/admin/log-viewer/add-log-server",
				data,
				'json'
			).done(function(data, textStatus, jqXHR) {
				if (data.success) {
					$("body").Vetology("vetologyShowDialog", "Success", "The log server has been added", "success");

				}
			}).fail(function(jqXHR, textStatus, errorThrown) {
				$("body").Vetology("vetologyShowDialog", "Error", jqXHR.responseText, "error");
			});
			o.options.dlg.dialog("close");
		}

	});
})(jQuery);
